import React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const RequestTypeChevronIcon = (props: SvgProps) => {
  return (
    <Svg width={22} height={22} viewBox="0 0 22 22" fill="none" {...props}>
      <Path
        d="M16.5 13.75L11.3536 8.60355C11.1583 8.40829 10.8417 8.40829 10.6464 8.60355L5.5 13.75"
        stroke="#0E7A41"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
}

export default RequestTypeChevronIcon
